module.exports = __webpack_public_path__ + "static/media/gallery0.cbc76fe1.jpeg";